<template>
  <div id="reestablecer container">
    <div class="principal">
      <nav class="navbar nav-masters">
        <a class="navbar-brand mx-auto" @click="IrALogin()">
          <img
            src="../../../../public/img/images/logo-emb.png"
            class="logo-embajadores"
          />
        </a>
      </nav>
    </div>
    <div class="div-login">
      <div class="contenedor-correo-enviado" v-if="this.mostrarMensaje">
        <p class="titulo-correo-enviado">
          Enviamos un correo a {{ this.correo }} para restablecer tu contraseña.
        </p>
      </div>
      <div class="contenedor-reestablece-contrasena" v-if="this.mostrarForm">
        <p class="titulo-reestablecer">
          Olvidé mi contraseña
        </p>
        <p class="parrafo-reestablecer">
          Ingresa el correo con el que fuiste registrado, para recuperar tu
          contraseña.
        </p>
        <form autocomplete="off" @submit.prevent="ReestablecerContrasena()">
          <input
            v-model="correo"
            type="email"
            class="form-control input-login"
            name="correo"
            placeholder="Correo electrónico"
            required
          />
          <button
            type="submit"
            id="sendlogin"
            class="btn btn-block btn-login w-100"
          >
            Restablecer
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

//Rutas
const rutaReestablecerContrasena = "api/Identity/EnviarCorreoRecuperacion";

export default {
  name: "ReestablecerContrasenia",
  data() {
    return {
      correo: null,
      mostrarMensaje: false,
      mostrarForm: true
    };
  },
  methods: {
    IrALogin() {
      this.$router.push({ name: "LoginMaster" });
    },
    ReestablecerContrasena() {
      axios
        .post(rutaReestablecerContrasena + "?correo=" + this.correo)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.mostrarMensaje = true;
            this.mostrarForm = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          } else if (resp.data.estado === 1) {
            this.mostrarMensaje = false;
            this.mostrarForm = true;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/estilos/estilosgenerales.scss";

.nav-masters {
  background-color: #ffffff;
  border-style: none;
}
.principal {
  text-align: center;
  padding-bottom: 6px;
  background: linear-gradient(
    90deg,
    #9e6353 0%,
    #a16555 22.05%,
    #a86d5b 31.23%,
    #b57a65 38.02%,
    #ca9076 43.63%,
    #e6ad8d 48.46%,
    #f6be9a 50.49%,
    #eeb590 51.88%,
    #dea47d 55.64%,
    #d39770 60.13%,
    #cd9168 65.98%,
    #cb8f66 78.29%,
    #9e6353 100%
  );
  background-size: 100% 5px;
}
.logo-embajadores {
  cursor: pointer;
  height: 80px;
  width: 180px;
  margin-right: 25px;
}

.div-login {
  background: url("../../../../public/img/images/ciudad2.png") no-repeat center
    center fixed;
  background-size: cover;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.titulo-reestablecer {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0.05em;
}
.titulo-correo-enviado {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0.05em;
}

.parrafo-reestablecer {
  color: #ffffff;
  text-align: justify;
  font-size: 16px;
}
.input-login {
  margin-top: 10px;
  height: 50px;
  border-radius: 0px;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  color: rgba(30, 33, 32, 0.55);
  border-style: none;
}

.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: #ffffff;
  outline: none;
  box-shadow: none;
}

.btn-login {
  margin-top: 10px;
  border: 1px solid $color-primario;
  border-radius: 0px;
  height: 50px;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
  background-color: $color-primario;
  font-family: $poppins;
}

@media all and (min-width: 768px) and (max-width: 1024px) {
}

@media all and (max-width: 767px) {
  .titulo-reestablecer {
    font-size: 20px;
  }
  .parrafo-reestablecer {
    font-size: 14px;
  }
  .input-login {
    height: 40px;
  }
  .btn-login {
    height: 40px;
  }
}
</style>
